<nz-modal [(nzVisible)]="isWarning" [nzContent]="modalContent" [nzFooter]="null" [nzClosable]="false" nzWidth="750">
  <ng-template #modalContent>
    <div nz-row>
      <div nz-col nzXs="24" nzLg="24" nzXl="24" class="text-center">
        <img src="./assets/images/LOGOTL.png" class="img-logo">
      </div>
    </div>
    <div nz-row>
      <div nz-col nzXs="24" nzLg="24" nzXl="24" class="text-center">
        <div class="header-font-size popup-title">ประกาศ</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col nzSpan="1"></div>
      <div nz-col nzSpan="23" class="popup-detail body-font-size">
        <div [innerHTML]="textWarnnig"></div>
      </div>
    </div>
    <div nz-row class="mt-4 mb-2">
      <div nz-col nzSpan="24" class="pr-1">
        <div class="btn-wrapper" style="text-align: center;">
          <div (click)="closeModal()" class="btn-styles text-center btn-blue body-font-size">
            <div class="txt">
              <button class="body-font-size" type="button">{{'ok' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</nz-modal>